import React from 'react'

import triggerEvent from 'utils/dataLayer'

import MenuItem from './MenuItem'

const StickyMobileMenu = ({ activeMenu, setActiveMenu }) => (
  <div className="mobile-menu">
    <div className="mobile-menu-container">
      <div className="mobile-menu-items">
        <MenuItem
          iconName={activeMenu === 'idle' ? 'homeActive' : 'home'}
          label="Beranda"
          url="/"
          data-testid="menu-home-mb"
          onClick={() => triggerEvent('ga/global/button-navbar/home')}
          isActive={activeMenu === 'idle'}
        />
        <MenuItem
          iconName={activeMenu === 'directory' || activeMenu === 'directory-page' ? 'menuActive' : 'menu'}
          label="Direktori"
          onClick={() => {
            setActiveMenu('directory')
            triggerEvent('ga/global/button-navbar/directory')
          }}
          data-testid="menu-direktori-mb"
          isActive={activeMenu === 'directory' || activeMenu === 'directory-page'}
        />
        <MenuItem
          iconName={activeMenu === 'favourite' ? 'heartActive' : 'heartOutline'}
          label="Favorit"
          url={activeMenu !== 'favourite' ? '/likes/schools' : '#'}
          data-testid="menu-favovit-mb"
          onClick={() => triggerEvent('ga/global/button-navbar/favourite')}
          isActive={activeMenu === 'favourite'}
        />
        <MenuItem
          iconName="assessmentHistory"
          label="Riwayat Tes"
          url={activeMenu !== 'assessment-history' ? '/aptitude_test/history' : '#'}
          data-testid="menu-riwayat-mb"
          onClick={() => triggerEvent('ga/global/button-navbar/history')}
          isActive={activeMenu === 'assessment-history'}
          checkTerms
        />
        <MenuItem
          iconName={activeMenu === 'profile' || activeMenu === 'profile-page' ? 'userActive' : 'user'}
          label="Profil"
          onClick={() => {
            setActiveMenu('profile')
            triggerEvent('ga/global/button-navbar/profile')
          }}
          data-testid="menu-profil-mb"
          isActive={activeMenu === 'profile' || activeMenu === 'profile-page'}
        />
      </div>
    </div>
    <style jsx>
      {`
        .mobile-menu {
          z-index: 98;
          height: 56px;
          box-shadow: 0 -2px 12px 0 rgba(26, 52, 79, 0.1);
          background-color: #ffffff;

          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          width: 100%;

          &-container {
            padding: 0 8px;
          }
          &-items {
            display: flex;
            justify-content: space-between;
            :global(span) {
              line-height: 12px;
            }
          }
          @media screen and (min-width: 768px) {
            display: none;
          }
        }
      `}
    </style>
  </div>
)

export default StickyMobileMenu
